export const formatDateToLongFormat = (dateString: string): string => {
  if (!dateString) return '-';
  try {
    const [month, day, year] = dateString.split(' ')[0].split('-');
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    const dayOfMonth = date.getDate();
    const monthName = date.toLocaleString('en-US', { month: 'long' });
    const fullYear = date.getFullYear();
    return `${dayOfMonth} ${monthName} ${fullYear}`;
  } catch (error) {
    console.error('Error formatting date in formatDateToLongFormat:', dateString, error);
    return '-';
  }
};

export const formatISOToShortDate = (isoDate: string): string => {
  if (!isoDate) return '-';
  try {
    const date = new Date(isoDate);
    const dayOfMonth = date.getDate();
    const monthName = date.toLocaleString('en-US', { month: 'short' });
    return `${dayOfMonth} ${monthName}`;
  } catch (error) {
    console.error('Error formatting date in formatISOToShortDate:', isoDate, error);
    return '-';
  }
};

export const formatBlogDate = (dateString: string): string => {
  if (!dateString) return '-';
  try {
    const [datePart] = dateString.split(' ');
    const [month, day, year] = datePart.split('-');
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    const dayOfMonth = date.getDate();
    const monthName = date.toLocaleString('en-US', { month: 'short' });
    const fullYear = date.getFullYear();
    return `${dayOfMonth} ${monthName} ${fullYear}`;
  } catch (error) {
    console.error('Error formatting date in formatBlogDate:', dateString, error);
    return '-';
  }
};

export const formatApiDateToDisplay = (dateString: string): string => {
  if (!dateString || dateString === '-') return '-';
  try {
    // Parse ISO 8601 date (e.g., "2025-09-02T10:11:02.033870Z")
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.error('Invalid date in formatApiDateToDisplay:', dateString);
      return '-';
    }
    const dayOfMonth = date.getDate();
    const monthName = date.toLocaleString('en-US', { month: 'short' });
    const fullYear = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Convert to 12-hour format
    const formattedMinutes = minutes.toString().padStart(2, '0');
    return `${monthName} ${dayOfMonth}, ${fullYear}, ${formattedHours}:${formattedMinutes} ${ampm}`;
  } catch (error) {
    console.error('Error formatting date in formatApiDateToDisplay:', dateString, error);
    return '-';
  }
};
